import PageHeader from "components/PageHeader";
import Spinner from "components/Spinner";
import { t } from "i18next";
import { useState } from "react";
import { ACTIVITY_TABS } from "../../Agent/constants";
import ActivityTabs from "./components/ActivityTabs";
import Info from "./components/Info";
import "./index.scss";
import useDetail from "./useDetail";

function AgentDetail() {
  const { sellerDetail, loading, refetch } = useDetail();
  const [activeTab, setActiveTab] = useState(ACTIVITY_TABS.ACTIVE_HISTORY);

  return (
    <div className="wrapper">
      <Spinner loading={loading} />
      <PageHeader
        pageTitle={t("seller.activitylogtabs.detailInfo")}
        routes={[
          {
            path: "/setting",
            name: t("seller.systemSetting"),
          },
          {
            path: "/seller",
            name: t("seller.sellerAccManage"),
          },
          {
            path: "",
            name: t("seller.activitylogtabs.detailInfo"),
          },
        ]}
      />

      <Info dataDetail={sellerDetail} refetch={refetch} setActiveTab={setActiveTab} fromSeller={true} />
      <ActivityTabs supplierDetail={sellerDetail} activeKey={activeTab} onChange={setActiveTab} />
    </div>
  );
}

export default AgentDetail;
